import type { FC, ReactNode } from 'react'

import { ARC } from '@/components/generals/arcade'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PixelScreen, ScreenPrompt } from '@/components/generals/pixel-screen'
import ContactWindow from '@/components/landing/contact/contact-window'
import { CONTACT_PAGE } from '@/components/landing/contact/data'
import { RESUME } from '@/components/landing/cabinet/data'

const Contact: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Contact' description={CONTACT_PAGE.meta} />

            <div className={ARC.page}>
                <div className={ARC.wrap}>
                    <PixelScreen
                        caption="Player 2"
                        word="Contact"
                        subcaption="Join the game"
                        heading={`Contact ${RESUME.name}`}
                        short
                    >
                        <ScreenPrompt target='message' action="to write" />
                    </PixelScreen>

                    <ContactWindow />
                </div>
            </div>
        </Layout>
    )
}

export default Contact
